import React from 'react';
import { motion } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBook, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';

const EmptyStudyState = ({ theme }) => {
  const navigate = useNavigate();

  const styles = {
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '50vh',
      padding: '2rem',
    },
    card: {
      background: theme?.background?.card,
      borderRadius: '1.5rem',
      padding: '3rem',
      border: `1px solid ${theme?.borders?.primary}`,
      boxShadow: theme?.shadows?.base,
      textAlign: 'center',
      maxWidth: '400px',
      width: '100%',
    },
    iconWrapper: {
      width: '5rem',
      height: '5rem',
      borderRadius: '1rem',
      background: `linear-gradient(135deg, ${theme?.primary?.blue?.[100]}20, ${theme?.primary?.blue?.[200]}30)`,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: '0 auto 1.5rem',
      fontSize: '2.5rem',
      color: theme?.primary?.blue?.[500],
    },
    title: {
      fontSize: '1.5rem',
      fontWeight: '600',
      color: theme?.text?.primary,
      marginBottom: '0.75rem',
    },
    message: {
      fontSize: '0.875rem',
      color: theme?.text?.secondary,
      lineHeight: 1.6,
      marginBottom: '2rem',
    },
    button: {
      background: `linear-gradient(135deg, ${theme?.primary?.blue?.[500]} 0%, ${theme?.primary?.blue?.[600]} 100%)`,
      color: 'white',
      border: 'none',
      borderRadius: '0.75rem',
      padding: '0.75rem 1.5rem',
      fontSize: '0.875rem',
      fontWeight: '500',
      cursor: 'pointer',
      display: 'inline-flex',
      alignItems: 'center',
      gap: '0.5rem',
      transition: 'all 0.3s ease',
      boxShadow: `0 4px 12px ${theme?.primary?.blue?.[500]}30`,
    },
    buttonHover: {
      transform: 'translateY(-2px)',
      boxShadow: `0 6px 20px ${theme?.primary?.blue?.[500]}40`,
    },
  };

  return (
    <div style={styles.container}>
      <motion.div
        style={styles.card}
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
      >
        <motion.div
          style={styles.iconWrapper}
          animate={{ 
            scale: [1, 1.1, 1],
          }}
          transition={{ 
            duration: 2,
            repeat: Infinity,
            repeatDelay: 1,
          }}
        >
          <FontAwesomeIcon icon={faBook} />
        </motion.div>
        
        <h2 style={styles.title}>No Study Content Available</h2>
        
        <p style={styles.message}>
          Study questions are being prepared for your certification. Please check back later or explore other features.
        </p>
        
        <motion.button
          style={styles.button}
          whileHover={styles.buttonHover}
          whileTap={{ scale: 0.95 }}
          onClick={() => navigate('/home')}
        >
          Go to Dashboard
          <FontAwesomeIcon icon={faArrowRight} />
        </motion.button>
      </motion.div>
    </div>
  );
};

export default EmptyStudyState;